export const FLAG_NAME_REQUIRED_MESSAGE = "Flag is required";

export const FLAG_COLOR_REQUIRED_MESSAGE = "Color is required";

/** Accepts 3-digit (#FFF) or 6-digit (#FFFFFF) hex color codes. */
export const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

export const FLAG_COLOR_INVALID_MESSAGE =
  "Enter a valid hex color code (e.g. #512DA8)";
